<template>
  <div class="app">
    <div v-if='tdbVisible'>
      <TempDesignBanner 
        :tdbHeight='tdbHeight' 
        @updateTdbHeight='tdbHeight = $event' 
        @tdbCloseFunc="tdbCloseFunc" 
      />
    </div>
      <AppHeader 
        :tdbHeight='tdbHeight' 
        :headerHeight='headerHeight' 
        @updateHeaderHeight='headerHeight = $event' 
      />
    <div 
      class='app-body' 
      :style="{'margin-top': tdbHeight + headerHeight + 'px'}"
    >
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside, Footer as AppFooter, Breadcrumb, TempDesignBanner } from '../components/'

export default {
  name: 'full',
  components: {
    TempDesignBanner,
    AppHeader,
    Sidebar,
    Aside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.items,
      tdbVisible: true,
      tdbHeight: 0,
      headerHeight: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  methods: {
    tdbCloseFunc () {
      this.tdbVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue